import script from "./SalesRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesRecord.vue?vue&type=script&setup=true&lang=js"

import "./SalesRecord.vue?vue&type=style&index=0&id=700e02a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-700e02a5"]])

export default __exports__